import { Col, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ContentArea = styled.div`
  display: flex;
  flex-direction: row;
  width: 1140px;
  height: 100%;
  position: relative;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const Wrapper = styled(Col)`
  width: 100%;
  height: 316px;
  margin: 88px 0 0;
  ${(props) => props.src && `background-image: url(${props.src})`};
  background-size: cover;

  @media (max-width: 1024px) {
    margin: 26px 0 0;
    height: 308px;
    justify-content: flex-start;
  }

  @media (min-width: 1024px) {
    align-items: center;
  }
`;

const BannerTextContainer = styled.div`
  z-index: 3;

  .text-1,
  .text-2,
  .text-3,
  .text-4 {
    font-size: 170px;
    letter-spacing: -13px;
    position: absolute;
    color: ${theme.SECONDARY};
  }

  .text-1 {
    top: 44px;
    left: -13px;
  }

  .text-2 {
    top: 174px;
    left: 190px;
  }

  @media (max-width: 1024px) {
    top: 160px;
    width: 99%;

    .text-1,
    .text-2,
    .text-3,
    .text-4 {
      font-size: 80px;
      letter-spacing: -3px;
    }

    .text-1 {
      top: 139px;
      left: 5px;
    }

    .text-2 {
      top: 201px;
      left: 111px;
    }
  }
`;

const TitleText = styled(Text)`
  position: absolute;
  top: -53px;
  left: 0px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const SlamDunkImg = styled.img`
  height: 381px;
  position: absolute;
  left: 260px;
  position: absolute;
  bottom: -15px;
  z-index: 2;

  @media (max-width: 1024px) {
    left: -111px;
    bottom: inherit;
    top: -21px;
    height: 226px;
    z-index: 1;
  }
`;

const AthleteImg = styled.img`
  width: 440px;
  position: absolute;
  right: 0;
  bottom: -15px;
  z-index: 2;

  @media (max-width: 1024px) {
    top: -21px;
    width: 266px;
    height: 227px;
    right: -2px;
  }
`;

const BlackSpace = styled.div`
  width: 550px;
  height: 334px;
  position: absolute;
  top: 30px;
  background-color: black;

  @media (max-width: 1024px) {
    top: inherit;
    bottom: 0px;
    height: 185px;
  }
`;

const Banner = (props) => {
  const { t } = useTranslation();

  return (
    <Wrapper src={require('assets/images/fans-background.png')}>
      <ContentArea>
        <TitleText lineHt="30px" size="20px">
          {t('website.fanZoneSmall')}
        </TitleText>

        <BannerTextContainer>
          <Text stencil col="#fff" className="text-1">
            {t('website.ledBy')}
          </Text>

          <Text stencil col="#fff" className="text-2">
            {t('website.fans.')}
          </Text>
        </BannerTextContainer>

        <SlamDunkImg src={require('assets/images/homepage-fan-lady.png')} />

        <AthleteImg src={require('assets/images/fans-cheering.png')} />

        <BlackSpace />
      </ContentArea>
    </Wrapper>
  );
};

export default Banner;
